"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GQLQueryHook = void 0;
const react_hooks_1 = require("@apollo/react-hooks");
const gql_1 = __importDefault(require("../gql"));
const constructVariables_1 = __importDefault(require("../helpers/constructVariables"));
function GQLQueryHook(configInput = {}) {
    return (o = { variables: {} }) => {
        const { variables = {} } = o, otherOptions = __rest(o, ["variables"]);
        const mergedOptions = Object.assign({}, configInput, o);
        const { name, model } = mergedOptions;
        const gqlObject = (0, gql_1.default)(mergedOptions);
        const options = Object.assign(Object.assign({ errorPolicy: 'all' }, (0, constructVariables_1.default)(configInput, variables)), otherOptions);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { loading, data, refetch, error } = (0, react_hooks_1.useQuery)(gqlObject, options);
        if (data && model) {
            return {
                loading,
                data: (data === null || data === void 0 ? void 0 : data[name]) ? new model(data[name]) : undefined,
                refetch,
                error,
            };
        }
        else {
            return { loading, data: data ? data[name] : undefined, refetch, error };
        }
    };
}
exports.GQLQueryHook = GQLQueryHook;
exports.default = GQLQueryHook;
